import { jsx as _jsx } from "react/jsx-runtime";
import { Card } from '@repo/ui';
import { getLabels } from '../../labels';
import PropertiesSection from './PropertiesSection';
export default function PropertiesCard({ properties, testId, showHelperText, collapsible, defaultOpen }) {
    return (_jsx(Card, { title: getLabels().property.title, collapsible: collapsible, defaultOpen: defaultOpen, testId: testId.append('card'), children: properties && _jsx(PropertiesSection, { properties: properties, testId: testId, showHelperText: showHelperText }) }));
}
